import { render, staticRenderFns } from "./ActivityLinked.vue?vue&type=template&id=c8cf85ee&scoped=true&lang=pug&"
import script from "./ActivityLinked.vue?vue&type=script&lang=js&"
export * from "./ActivityLinked.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLinked.vue?vue&type=style&index=0&id=c8cf85ee&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cf85ee",
  null
  
)

export default component.exports